import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import { Partner } from './Partner';
import { fetchPartners } from '../../actions/actions';

import { Grid, Divider, Header, Container } from 'semantic-ui-react';

class Partners extends Component {
  componentDidMount() {
    this.props.dispatch(fetchPartners());
  }

  render() {
    const availablePartners = (this.props.partnerList) ? this.props.partnerList : [];

    return (
      <Container className="smt">
        <Divider horizontal><Header as='h3'>Kiemelt partnereink</Header></Divider>
        <Grid>
          <Grid.Row centered>
            {
              availablePartners.map( partner =>
                <Partner partner={partner} /> )
            }
          </Grid.Row>
          <Grid.Row centered>
            <Header as='h4'>
              Innovatív eszközeinkkel és megoldásainkkal mindenki számára megtaláljuk a leghatékonyabb reklámozási megoldást. Csatlakozzon innovatív médiafelületeinken hirdető Partnereink közé!
            </Header>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    partnerList: state.partners.partnerList,
    isFetching: state.partners.isFetching
  }
}

export default connect(mapStateToProps)(Partners);



// WEBPACK FOOTER //
// ./src/components/partners/Partners.js